import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-my-account-tab3',
  templateUrl: './my-account-tab3.component.html',
  styleUrls: ['./my-account-tab3.component.scss']
})
export class MyAccountTab3Component implements OnInit {
  MATitle = 'Password'
  MAPassInfoTitle = "To change your password please enter your current password so we know if it's you."

  MAPasswordForm = [
    {
      for: 'MACurrentPassword',
      text: 'Current Password',
      type: 'text',
      className: 'form-control',
      id: 'MACurrentPassword',
      placeHolder: 'Current Password'
    },
    {
      for: 'MAPassUpdate',
      text: 'Update',
      type: 'submit',
      className: 'btn next-btn form-control',
      id: 'MAPassUpdate',
      value: 'Edit Password'
    }
  ]

  constructor() { }

  ngOnInit() {
  }

}
